import React from 'react';

export type DividerWrapperProps = {
  divider: React.ReactNode;
  children: React.ReactNode[];
};

export const DividerWrapper: React.FunctionComponent<DividerWrapperProps> = props => {
  const { divider, children } = props;
  const filteredChildren = children.filter(child => child != null);

  return (
    <>
      {filteredChildren.map((child, index) => (
        <React.Fragment key={index}>
          {child}
          {index < filteredChildren.length - 1 && divider}
        </React.Fragment>
      ))}
    </>
  );
};
